<template>
  <div>
    <v-card class="card--flex-toolbar" flat>
        <v-tabs color="grey lighten-3" v-model="current_tab" dark slider-color="grey darken-4">
            <v-tab ripple v-for="tab in tabs" :key="tab.href" :to="{name: tab.route_name}" class="grey--text text--darken-4 caption">{{tab.text}}</v-tab>
        </v-tabs>
    </v-card>
    <v-card v-if="isLoading" height="50vh">
      <h1></h1>
    </v-card >
    <router-view v-else
      :program.sync="program"
      @update="save"
      @cancel="cancel"
    ></router-view>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapGetters } from 'vuex';
import { tzToUtc, utcToTz } from '@/helper'

export default {
  name: "ProgramIdRoot",
  data() {
    return {
      active: null,
      current_tab: 'overview',
      isLoading: false,
      tabs: [
        {
          text: i18n.t('program.update.tab.basic_detail'),
          route_name: 'programs.update'
        },
        {
          text: i18n.t('program.update.tab.events'),
          route_name: 'programs.events'
        },
        {
          text: i18n.t('program.update.tab.filters'),
          route_name: 'programs.filters'
        },
      ],
      program:null
    };
  },
  computed: {
    ...mapGetters('company', {
      currentCompanyId:'getSelected',
      timezone: 'getSelectedCompanyTimezone',
    }),
  },
  mounted(){
    this.get();
    this.getTags(this.DEFINES.TAG_TYPE.FOR_PROGRAM_FILM_SECTIONS);
    this.getTags(this.DEFINES.TAG_TYPE.FOR_PROGRAM_FILM_TYPES);
  },
  methods: {
    async get() {
      try {
          if (this.$route.params.program_id == undefined) {
            return;
          }
          let result = await this.$store.dispatch("program/get", {
            program_id: this.$route.params.program_id,
          });
          this.program = result.program;
          this.program.starts_at = utcToTz(this.program.starts_at, this.timezone);
          this.program.ends_at = utcToTz(this.program.ends_at, this.timezone);
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    async getTags(tag_type) {
      try {
        await this.$store.dispatch("tag/list", {
          tag_type
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    async save(){
      try {
        this.program.status = this.program.status?1:0;
        let formData = Object.assign({}, this.program);
        formData = await this.transformFormData(formData);
        await this.$store.dispatch("program/update", formData);
        this.get()
        this.$store.dispatch("app/showMessage", {
          message: i18n.t('program.updated.successfully.message'),
          color: "success"
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
    cancel(){
      this.$router.push({
          name: 'programs.list',
          params: {
            company_id: this.currentCompanyId,
          },
      })
    },
    transformFormData(formData) {
      let data = Object.assign({}, formData)

      // Transform starts at
      data.starts_at = tzToUtc(
        data.starts_at,
        this.timezone
      );

      // Transform ends at
      data.ends_at = tzToUtc(
        data.ends_at,
        this.timezone
      );

      return data

    },
  }
};
</script>
